import About from "./components/About";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import {Routes, Route, useLocation} from 'react-router-dom';
import Footer from "./components/Footer";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Artifacts from "./components/Artifacts";
import Work from "./components/Work";
import LatestPics from "./components/LatestPics";
import Portugal from "./components/Portugal";
import Turkey from "./components/Turkey";
import Bday from "./components/Bday";

function AppContent() {
  const location = useLocation();
  const isTripRoute = location.pathname === '/lagutrop' || location.pathname === '/turkey' || location.pathname === '/bday';

  return (
    <div className="h-full">
     {!isTripRoute && <Navbar className = 'z10'/>}
     <Routes>
      <Route path = '/' element = {<Home />}/>
      <Route path = '/about' element = {<About title='About'/>}/>
      <Route path = '/work' element = {<Work title='Work'/>}/>
      <Route path = '/skills' element = {<Skills title='Skills'/>}/>
      <Route path = '/projects' element = {<Projects title='Projects'/>}/>
      <Route path = '/artifacts' element = {<Artifacts title='Artifacts'/>}/>
      <Route path = '/contact' element = {<Contact title='Contact'/>}/>
      <Route path = '/latestpics' element = {<LatestPics title='Latest Pics'/>}/>
      <Route path = '/lagutrop' element = {<Portugal />}/>
      <Route path = '/turkey' element = {<Turkey />}/>
      <Route path = '/bday' element = {<Bday />}/>
     </Routes>
    
     
    
    </div>
  );
}

function App() {
  return <AppContent />;
}

export default App;
